import { SIDENAV_TOKENS } from '@app/components/layout/sidenav/sidenav-tokens';
import { AnchorPosition } from '@app/core/hooks';
import { NotificationsFeedContent } from '@app/modules/notifications/feed/NotificationsFeedContent';
import { NotificationsPopoverCloseProvider } from '@app/modules/notifications/feed/NotificationsPopoverCloseProvider';
import { Popover } from '@mui/material';

export type SidenavNotificationsPopoverProps = {
  open: boolean;
  anchorPosition: AnchorPosition | undefined;
  onClose: () => void;
};

/**
 * Notifications panel opened from the sidenav bell button.
 */
export function SidenavNotificationsPopover({
  open,
  anchorPosition,
  onClose,
}: SidenavNotificationsPopoverProps) {
  return (
    <Popover
      open={open}
      anchorReference="anchorPosition"
      anchorPosition={anchorPosition}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      marginThreshold={0}
      slotProps={{
        paper: {
          sx: {
            bgcolor: 'background.paper',
            color: 'text.primary',
            minWidth: SIDENAV_TOKENS.drawerWidth,
            width: 360,
            maxWidth: 'min(360px, 100vw)',
          },
        },
      }}
    >
      <NotificationsPopoverCloseProvider onClose={onClose}>
        <NotificationsFeedContent />
      </NotificationsPopoverCloseProvider>
    </Popover>
  );
}
